import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const typeColor   = { JOB:'chip-blue', SERVICE:'chip-teal', TASK:'chip-green', FREELANCE:'chip-amber' };
const statusColor = { OPEN:'chip-green', ASSIGNED:'chip-blue', COMPLETED:'chip-teal', CLOSED:'chip-gray', PENDING_VERIFY:'chip-amber' };

export default function JobCard({ job, onApply, applied }) {
  const { t, user } = useApp();
  const canApply = user?.role === 'SEEKER' && job.status === 'OPEN';

  return (
    <div className="card job-card fade-in" style={{ marginBottom: '10px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Link to={`/jobs/${job.id}`}
            style={{ color: 'var(--text)', fontWeight: 600, fontSize: '15px', textDecoration: 'none' }}>
            {job.title}
          </Link>
          <div style={{ fontSize: '13px', color: 'var(--text3)', marginTop: '4px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <span>📍 {job.location}</span>
            <span>৳ {Number(job.budget).toLocaleString()}</span>
            {job.posterName && <span>by {job.posterName}</span>}
            <span>🕐 {new Date(job.createdAt).toLocaleDateString()}</span>
          </div>
          {job.description && (
            <p style={{ fontSize: '13px', color: 'var(--text2)', marginTop: '8px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
              {job.description}
            </p>
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px', flexShrink: 0 }}>
          <span className={`chip ${typeColor[job.type]   ?? 'chip-gray'}`}>{job.type}</span>
          <span className={`chip ${statusColor[job.status] ?? 'chip-gray'}`}>{job.status}</span>
        </div>
      </div>

      <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        {job.category && <span className="chip chip-gray">{job.category}</span>}
        <span style={{ flex: 1 }} />
        {job.applicantCount !== undefined && (
          <span style={{ fontSize: '12px', color: 'var(--text3)' }}>{job.applicantCount} {t('applicants')}</span>
        )}
        {canApply && (
          applied ? (
            <button className="btn btn-outline btn-sm" disabled style={{ opacity: 0.8 }}>
              ✅ {t('applied')}
            </button>
          ) : (
            <button className="btn btn-primary btn-sm" onClick={() => onApply?.(job)}>
              {t('apply')}
            </button>
          )
        )}
        <Link to={`/jobs/${job.id}`} className="btn btn-outline btn-sm">View</Link>
      </div>
    </div>
  );
}
